// extracted by mini-css-extract-plugin
export default {"comment":"Comment_comment__7nULy","comment-body":"Comment_comment-body__Tt3Ta"};